import RestService from "@/services/RestService";

function getBooks() {
  const data = {};
  return RestService.sendReq("get", "books", data);
}

function geReportCard() {
  const data = {};
  return RestService.sendReq("get", "report-card", data);
}

export default {
  getBooks,
  geReportCard,
};
